import React, { useCallback, useState } from 'react'
import { Box, Grid } from '@mui/material'
import Dialog from '../../../../components/dialog/Dialog'
import { DialogCommonProps } from '../../../../components/dialog/types/dialogModel'
import { ongletsAjoutType } from '../../enums/popinAjoutEnum'
import EntetePopinAjoutInterneExterne from './EntetePopinAjoutInterneExterne'
import { typeAjout } from './types/popinAjoutInterneExterneModel'
import FormSignataireInterne from './popinAjoutSignataire/components/FormSignataireInterne'
import FormSignataireExterne from './popinAjoutSignataire/components/FormSignataireExterne'
import FormSuiveurInterne from './popinAjoutSuiveur/components/FormSuiveurInterne'
import FormSuiveurExterne from './popinAjoutSuiveur/components/FormSuiveurExterne'

type PopinAjoutInterneExterneProps = DialogCommonProps & {
	type: typeAjout
}

const PopinAjoutInterneExterne: React.FC<PopinAjoutInterneExterneProps> = ({ onCloseDialog, open, type }) => {
	const [ongletActif, setOngletActif] = useState<string>(ongletsAjoutType.interne)

	const renderForm = useCallback(() => {
		switch (type) {
			case typeAjout.Signataire:
				return ongletActif === ongletsAjoutType.interne ? <FormSignataireInterne /> : <FormSignataireExterne />
			case typeAjout.Suiveur:
				return ongletActif === ongletsAjoutType.interne ? <FormSuiveurInterne /> : <FormSuiveurExterne />
		}
	}, [type, ongletActif])

	return (
		<Dialog
			onCloseDialog={() => {
				onCloseDialog()
				setOngletActif(ongletsAjoutType.interne)
			}}
			open={open}
			fullScreen={false}
			withPadding={false}
			maxWidth={false}
		>
			<Box
				justifyContent="center"
				sx={{
					width: 800,
					height: 700,
					ml: '40px',
					mr: '40px'
				}}
			>
				<EntetePopinAjoutInterneExterne onCloseDialog={onCloseDialog} ongletActif={ongletActif} setOngletActif={setOngletActif} />
				<Grid container item xs={12} justifyContent="space-evenly" sx={{ height: 122, mt: '20px', mb: '20px' }}>
					{renderForm()}
				</Grid>
			</Box>
		</Dialog>
	)
}

export default PopinAjoutInterneExterne